import { Alert, Button, Paper, Slide, SlideProps, Snackbar } from "@mui/material";
import { useState, useRef, BaseSyntheticEvent, SyntheticEvent } from "react";
import CustomHr from "../../common/customhr";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import DifferenceIcon from "@mui/icons-material/Difference";
import RefreshIcon from "@mui/icons-material/Refresh";
import "./upload.component.scss";
import { callDiffingApi } from "../../services/diffing.service";
import CustomLoader from "../../common/customloader";
import CustomIframeLoader from "../../common/customiframeloader";


const SlideTransition = (props: SlideProps) => {
    return <Slide {...props} direction="left" />
}

const UploadComponent = () => {

    const [newFile, setNewFile] = useState("");
    const [newFileName, setNewFileName] = useState("");
    const newFileRef = useRef<HTMLInputElement>(null);
    const [oldFile, setOldFile] = useState("");
    const [oldFileName, setOldFileName] = useState("");
    const oldFileRef = useRef<HTMLInputElement>(null);
    const [loadingResults, setLoadingResults] = useState<boolean>(false);
    const [openSnackBar, setOpenSnackBar] = useState<boolean>(false);
    const [message, setMessage] = useState("");
    const [severity, setSeverity] = useState("");
    const [iFrameURL, setIframeURL] = useState("");

    const handleFileChange = (event: BaseSyntheticEvent) => {
        event.preventDefault();
        event.preventDefault();
        const reader = new FileReader();
        const file = event.target.files[0];
        const fileName: string = file.name;
        const fileId = event.target.id;

        if (fileId === "old-file") {
            reader.onloadend = () => {
                setOldFile(file);
                setOldFileName(fileName);
            }
            reader.readAsDataURL(file);
        } else if (fileId === "new-file") {
            reader.onloadend = () => {
                setNewFile(file);
                setNewFileName(fileName);
            }
            reader.readAsDataURL(file);
        }

    }

    const sendRequest = (event: SyntheticEvent) => {
        setLoadingResults(true);
        setIframeURL("");
        event.preventDefault();
        event.stopPropagation();

        let formData = new FormData();
        formData.append("old_file", oldFile, oldFileName);
        formData.append("new_file", newFile, newFileName);

        callDiffingApi(formData).then((res: any) => {
            if (res.data) {
                setIframeURL(res.data.file);
            }
            setMessage("Files Processed Successfully.");
            setSeverity("success");
            setOpenSnackBar(true);
            setLoadingResults(false);
            setTimeout(() => {
                const diffIframe = document.getElementById("diff-iframe");
                if (diffIframe) {
                    diffIframe.scrollIntoView(
                        {
                            behavior: "smooth",
                            block: "start",
                            inline: "start"
                        }
                    );
                }
            }, 400);
        }).catch((err: any) => {
            console.error(err);
            setMessage("Unable to Process Files.");
            setSeverity("error");
            setOpenSnackBar(true);
            setLoadingResults(false);
        });
    }

    const handleReset = (event: SyntheticEvent) => {
        event.preventDefault();
        event.stopPropagation();
        setNewFile("");
        setNewFileName("");
        setOldFile("");
        setOldFileName("");
        setIframeURL("");

        if (newFileRef.current) {
            newFileRef.current.value = "";
        }

        if (oldFileRef.current) {
            oldFileRef.current.value = "";

        }
    }


    const handleSnackbarClose = (event: SyntheticEvent | Event, reason?: string) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenSnackBar(false);
    }

    return <div className="container-fluid">
        <div className="row">
            {!loadingResults &&
                <Paper className="col-8 offset-2 upload-parent mt-3 mb-3">
                    <h5 className="text-center pt-3 pb-1">
                        COMPARE FILES
                        <CustomHr />
                    </h5>
                    <div className="row">
                        <div className="col-6 text-center">
                            <label htmlFor="old-file">
                                <input
                                    type="file"
                                    name="old-file"
                                    id="old-file"
                                    ref={oldFileRef}
                                    onChange={handleFileChange}
                                    accept="application/json, application/yaml, application/xml, text/plain, application/x-yaml"
                                />
                                <Button
                                    variant="contained"
                                    component="span"
                                    size="medium"
                                    color="secondary"
                                    startIcon={<InsertDriveFileIcon />}
                                    sx={{ fontWeight: "bold", fontFamily: "Signika" }}
                                >
                                    Choose Old File
                                </Button>
                            </label>
                        </div>
                        <div className="col-6 text-center">
                            <label htmlFor="new-file">
                                <input
                                    type="file"
                                    name="new-file"
                                    id="new-file"
                                    ref={newFileRef}
                                    onChange={handleFileChange}
                                    accept="application/json, application/yaml, application/xml, text/plain, application/x-yaml"
                                />
                                <Button
                                    variant="contained"
                                    component="span"
                                    size="medium"
                                    color="secondary"
                                    startIcon={<InsertDriveFileIcon />}
                                    sx={{ fontWeight: "bold", fontFamily: "Signika" }}
                                >
                                    Choose New File
                                </Button>
                            </label>
                        </div>
                        <div className="col-6 mt-3 text-center">
                            <h6 className="text-center">
                                {oldFile ? oldFileName : "No Old File Selected"}
                            </h6>
                        </div>
                        <div className="col-6 mt-3 text-center">
                            <h6 className="text-center">
                                {newFile ? newFileName : "No New File Selected"}
                            </h6>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6 text-end">
                            <Button
                                variant="contained"
                                startIcon={<RefreshIcon />}
                                sx={{ fontWeight: "bold", fontFamily: "Signika" }}
                                disabled={!newFile && !oldFile && !iFrameURL}
                                onClick={handleReset}
                            >
                                RESET
                            </Button>
                        </div>
                        <div className="col-6 text-start">
                            <Button
                                variant="contained"
                                startIcon={<DifferenceIcon />}
                                sx={{ fontWeight: "bold", fontFamily: "Signika" }}
                                disabled={!newFile || !oldFile}
                                onClick={sendRequest}
                            >
                                COMPARE
                            </Button>
                        </div>
                    </div>
                </Paper>
            }

            {
                loadingResults && <CustomLoader />
            }
            {
                iFrameURL &&
                <div className="iframe-parent">
                    <CustomIframeLoader
                        iframeURL={iFrameURL}
                        fileName={newFileName} />
                </div>
            }
        </div>
        <Snackbar
            open={openSnackBar}
            autoHideDuration={3000}
            anchorOrigin={{ horizontal: "right", vertical: "top" }}
            TransitionComponent={SlideTransition}
            onClose={handleSnackbarClose}
        >
            <Alert
                onClose={handleSnackbarClose}
                severity={severity === "success" ? "success" : "error"}
                sx={{ width: "100%" }}
            >
                {message}
            </Alert>
        </Snackbar>
    </div>
}

export default UploadComponent;